import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'neo-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    standalone: false
})
export class NeoChipComponent implements OnInit {
  @Input() class: string = "";
  @Input() text?: string;
  @Input() prefixIcon?: string;
  @Input() suffixIcon?: string;
  isPrefixIconSvg?: boolean;
  isSuffixIconSvg?: boolean;

   ngOnInit(): void {
    this.class = `${this.class} chip ${this.prefixIcon ? 'chip-prefix' : ''} ${this.suffixIcon ? 'chip-suffix' : ''}`;
    this.isPrefixIconSvg = this.prefixIcon?.startsWith('neo_')
    this.isSuffixIconSvg = this.suffixIcon?.startsWith('neo_')
  }
}
